<template>
  <div>
    <div class="searchBlock" v-if="isDynamic">
      <el-divider content-position="left">二维表搜索配置</el-divider>
      <el-form-item label="可搜索">
        <el-switch v-model="data.isSearch"></el-switch>
      </el-form-item>
      <!-- <el-form-item v-if="data.isSearch && data.multiple" label="搜索方式">
        <el-radio-group v-model="data.searchWay" size="small">
          <el-radio-button label="or">或查询</el-radio-button>
          <el-radio-button label="and">与查询</el-radio-button>
        </el-radio-group>
      </el-form-item> -->
    </div>
    <el-form>
    <el-form-item label="是否多选：">
      <el-switch v-model="data.multiple"></el-switch>
    </el-form-item>
    <el-form-item label="占位内容：" label-width="100px" label-position="left">
      <el-input v-model="data.placeholder"
                placeholder="占位内容"></el-input>
    </el-form-item>
    <el-form-item label="默认值：" label-width="100px" label-position="left">
      <el-input v-model="data.value"
                placeholder="默认值"></el-input>
    </el-form-item>
    <el-form-item label="多选数量限制："
                  v-if="data.multiple">
      <el-input-number v-model="data.limit"
                       controls-position="right"
                       placeholder="多选限制"
                       :min="0"
                       :max="data.dicData.length"></el-input-number>
    </el-form-item>
      <el-form-item label="是否关联本地：">
        <el-switch v-model="data.isLocal"></el-switch>
      </el-form-item>
      <el-form-item label="父级属性值：" v-if="data.isLocal">
        <el-input v-model="data.parentProp"></el-input>
      </el-form-item>
    <el-form-item label="字典配置：" label-postion="left"><br>
      <el-tabs v-model="data.dicOption"
               stretch
               @tab-click="handleTabClick">

        <el-tab-pane label="静态数据"
                     name="1" v-if="data.isLocal">
          <el-tree ref="tree"
                   :data="data.localDic"
                   default-expand-all
                   draggable
                   node-key="value"
                   :expand-on-click-node="false">
            <span class="custom-tree-node"
                  slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span>
                <el-button type="text"
                           size="mini"
                           icon="el-icon-plus"
                           @click="handleNodeAdd(data)"></el-button>
                <!--                <el-button class="warning" type="text" size="mini" icon="el-icon-edit"-->
                <!--                           @click="handleNodeEdit(data)"></el-button>-->
                <el-button class="danger"
                           type="text"
                           size="mini"
                           icon="el-icon-delete"
                           @click="handleNodeRemove(node, data)"></el-button>
              </span>
            </span>
          </el-tree>
          <div style="margin-left: 22px;">
            <el-button type="text"
                       @click="handleParentNodeAdd">添加父级
            </el-button>
          </div>
        </el-tab-pane>

        <el-tab-pane label="静态数据"
                     name="1"
                    v-else>
          <draggable tag="ul"
                     :list="dicdata"
                     :group="{ name: 'dic' }"
                     ghost-class="ghost"
                     handle=".drag-item">
            <li v-for="(item, index) in dicdata"
                :key="index">
              <i class="drag-item el-icon-s-operation"
                 style="font-size: 16px; margin: 0 5px; cursor: move;"></i>
              <el-input style="margin-right: 5px;"
                        size="mini"
                        v-model="item.label"
                        placeholder="label"></el-input>
              <el-input size="mini"
                        v-model="item.value"
                        placeholder="value"></el-input>
              <el-button @click="handleRemoveFields(index)"
                         circle
                         plain
                         type="danger"
                         size="mini"
                         icon="el-icon-minus"
                         style="padding: 4px;margin-left: 5px;"></el-button>
            </li>
          </draggable>
          <div style="margin-left: 22px;">
            <el-button type="text"
                       @click="handleAddFields">添加列
            </el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="远端数据"
                     name="2">
          网址
          <el-input v-model="data.dicUrl"
                    placeholder="远端数据字典网址"></el-input>
          请求方法
          <el-select v-model="data.dicMethod"
                     placeholder="请求方法"
                     style="width: 100%;">
            <el-option label="POST"
                       value="post"></el-option>
            <el-option label="GET"
                       value="get"></el-option>
          </el-select>
          标签值
          <el-input v-model="data.props.label"
                    placeholder="远端数据字典网址"></el-input>
          属性值
          <el-input v-model="data.props.value"
                    placeholder="远端数据字典网址"></el-input>
        </el-tab-pane>
        <!-- <el-tab-pane label="带参远端数据"
                     name="3">
          后端接口
          <el-input v-model="data.paramUrl"
                    placeholder="远端数据后端接口"></el-input>
          参数
          <el-input v-model="data.requestParams"
                    placeholder="多个参数以，分开"></el-input>
        </el-tab-pane> -->
      </el-tabs>
    </el-form-item>
    <el-divider content-position="left">动态显隐</el-divider>
    <caseCade :caseData="dynamicDisplayData" @replaceData="replaceCaseCade" />
    <!-- 扩展 字段采集 开始 -->
    <el-form-item label="采集资源:" v-if="!isDynamic">
      <el-select clearable v-model="data.resourceId" placeholder="请选择采集资源：" >
          <el-option
          v-for="item in resource"
          :key="item.resourceId"
          :label="item.tableComment"
          :value="item.resourceId">
          </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="采集字段:">
      <el-select clearable v-model="data.fieldName" placeholder="请选择采集字段">
          <el-option
          v-for="item in field"
          :key="item.columnName"
          :label="item.columnComment"
          :value="item.columnName">
          </el-option>
      </el-select>
    </el-form-item>
      <el-form-item label="是否回填：" v-if="!isDynamic">
      <el-switch v-model="data.writable"></el-switch>
    </el-form-item>
    <el-form-item label="联动URL：" label-width="100px" label-position="left">
        <el-input v-model="data.casUrl"></el-input>
    </el-form-item>
    <el-form-item label="尺寸：">
      <el-radio-group v-model="data.size"
                      size="mini">
        <el-radio-button label="medium">正常</el-radio-button>
        <el-radio-button label="small">小</el-radio-button>
        <el-radio-button label="mini">超小</el-radio-button>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否可清空：">
      <el-switch v-model="data.clearable"></el-switch>
    </el-form-item>
    <el-form-item label="是否可搜索：">
      <el-switch v-model="data.filterable"></el-switch>
    </el-form-item>
    <el-form-item label="是否禁用：">
      <el-switch v-model="data.disabled"></el-switch>
    </el-form-item>
    <el-form-item label="是否可见：">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <el-form-item label="列隐藏：" v-if="isDynamic">
      <el-switch v-model="data.hide"></el-switch>
    </el-form-item>
    <el-form-item label="是否必填：">
      <el-switch v-model="data.required"></el-switch>
    </el-form-item >
    <el-form-item label="部门下拉：">
      <el-switch v-model="data.isDepartSelect"></el-switch>
    </el-form-item >
      <!-- <el-form-item label="动态显隐：">
        <avue-dynamic v-model="data.dynamicHide"
                      :children="option"></avue-dynamic>
      </el-form-item> -->

      <el-dialog :visible.sync="dialogVisible"
                 :rules="dialogRules"
                 :before-close="beforeClose">
        <el-form ref="dialogForm"
                 :model="dialogForm"
                 label-width="80px">
          <el-form-item label="label">
            <el-input v-model="dialogForm.label"
                      placeholder="label"></el-input>
          </el-form-item>
          <el-form-item label="value">
            <el-input v-model="dialogForm.value"
                      placeholder="value"
                      :type="this.dialogInputType">
              <el-select v-model="dialogInputType"
                         slot="append"
                         placeholder="数据类型"
                         style="width: 100px">
                <el-option label="String"
                           value="text"></el-option>
                <el-option label="Number"
                           value="number"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="handleDialogAdd"
                   v-if="dialogStatus == 'add'">确 定</el-button>
          <!--        <el-button type="primary" @click="handleDialogUpdate" v-else>确 定</el-button>-->
      </span>
      </el-dialog>
    </el-form>
  </div>
</template>
<script>
import Draggable from 'vuedraggable'
import CaseCade from '../CaseCade'
import mixinIsDynamic from '../../mixins/isDynamic'

export default {
  mixins: [mixinIsDynamic],
  name: 'ConfigSelect',
  props: ['data', 'widgetForm'],
  components: { Draggable, CaseCade },
  data() {
    return {
      resource: [],
      field: [],
      validator: {
        type: null,
        required: null,
        pattern: null,
        length: null
      },
      dicOption: '1',
      dicCopy: this.deepClone(this.data.dicData),
      dataProps: {},
      dicdata: this.data.dicData || [],
      dynamicDisplayData: this.data.dynamicDisplayData || [],
      localdicdata: this.data.localDic,
      cascade: this.data.cascaderItem,
      dialogForm: {},
      dialogVisible: false,
      dialogRules: {
        label: { required: true, message: '请输入label' },
        value: { required: true, message: '请输入value' }
      },
      dialogStatus: 'add',
      selectData: undefined,
      dialogInputType: 'text',
      option: {
        column: [{
          type: 'input',
          prop: 'dynamicHideProp',
          label: '显隐prop'
        }, {
          type: 'input',
          prop: 'dynamicHideCondition',
          label: '显示条件'
        }]
      }
    }
  },
  updated() {

  },
  computed: {

  },
  mounted() {

  },
  methods: {
    handleParentNodeAdd() {
      this.selectData = undefined
      this.dialogStatus = 'add'
      this.dialogVisible = true
    },
    handleNodeAdd(data) {
      this.selectData = data
      this.dialogStatus = 'add'
      this.dialogVisible = true
    },
    handleNodeRemove(node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.label === data.label && d.value === data.value)
      children.splice(index, 1)
    },
    handleDialogAdd() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          const { label, value } = this.dialogForm
          const node = this.$refs.tree.getNode(value)
          if (node) this.$message.error('value重复')
          else {
            const data = this.selectData
            const newNode = {
              label,
              value: this.dialogInputType === 'number' ? Number(value) : value
            }
            if (data) {
              if (!data.children) this.$set(data, 'children', [])
              data.children.push(newNode)
            } else {
              this.$set(this.data.localDic, this.data.localDic.length, newNode)
            }
            this.beforeClose()
          }
        }
      })
    },
    beforeClose() {
      this.$refs.dialogForm.clearValidate()
      this.dialogForm = {}
      this.dialogVisible = false
    },
    handleAddProp() {
      const i = Math.ceil(Math.random() * 99999)
      this.cascade.push(i)
    },
    handleRemoveProp(index) {
      this.cascade.splice(index, 1)
    },
    generateRule() {
      const rules = []
      Object.keys(this.validator).forEach(key => {
        if (this.validator[key]) rules.push(this.validator[key])
      })
      this.data.rules = rules
    },
    handleRemoveFields(index) {
      // this.data.dicData.splice(index, 1)
      this.dicdata.splice(index, 1)
    },
    handleAddFields() {
      console.log('push data')
      const i = Math.ceil(Math.random() * 99999)

      this.dicdata.push({ label: `字段${i}`, value: `col_${i}` })

      // this.data.dicData.push({ label: `字段${i}`, value: `col_${i}` })
    },
    handleTabClick(tab) {
      const { name } = tab
      if (name === '1') {
        this.data.dicUrl = ''
        delete this.data.remote
        delete this.data.dicMethod
        this.data.props = {}
        this.dicdata = []
        this.data.dicData = []
      } else {
        delete this.data.dicData
        this.data.localDic = []
        this.data.remote = true
        // this.dicdata = []
        // this.$message.info('hello')
        // this.data.dicData = []
        /* this.data.dicUrl = ''*/
      }
    },
    replaceCaseCade(data) {
      this.data.dynamicDisplayData = data
    }
  },
  watch: {
    'data.resourceId': function(val) {
      if (val) {
        this.resourceIdChange(val)
      }
    },
    'data.dicFlag': function(val) {
      console.log(val)

      if (val === false) {
        delete this.data.cascaderItem
      } else {
        if (this.data.cascaderItem) {
          this.cascade = this.data.cascaderItem
        } else {
          this.data.cascaderItem = []
        }
      }
    },
    'data.required': function(val) {
      if (val) this.validator.required = { required: true, message: `请选择${this.data.label}` }
      else this.validator.required = null

      this.generateRule()
    },
    'data.dicData': {
      handler(val) {
        if (val && val.length > 0 && !Object.is(val, this.dicdata)) {
          this.dicdata = val
        }
      },

      deep: true
    },
    'data.cascaderItem': {
      handler(val) {
        if (val && !Object.is(val, this.cascade)) {
          console.log('watchj')
          console.log(val)
          this.cascade = val
        }
      },
      deep: true
    },
    cascade: {
      handler(val) {
        this.data.cascaderItem = val
      },
      deep: true
    },
    dicdata: {
      handler(val) {
        this.data.dicData = val
      },
      deep: true
    }

  }
}
</script>
